//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        title: {
            required: false,
        },
        closeModalText: {
            type: String,
            required: false,
            default: 'Sulje',
        },
        open: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        hide(event) {
            if (event.target.dataset.closetrigger) {
                this.$emit('close');
            }
        },
    },
};
